"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphElement = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const BlockPlaceholder_1 = require("./BlockPlaceholder");
const indentation_1 = require("../../behavior/indentation");
const font_1 = require("../../behavior/font");
const css_1 = require("../../custom-style/css");
const util_1 = require("../../util");
const paragraphClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    mr: '0 0 1.2em',
    lh: (0, css_1.lhVar)('1.8'),
});
const ParagraphElement = ({ attributes, children, element }) => (React.createElement("p", { ...attributes, className: paragraphClass, style: {
        textAlign: element.align,
        paddingInlineStart: (0, indentation_1.indentPadding)(element.indent),
        fontFamily: (0, font_1.fontFamilyOf)(element.font),
    } },
    children,
    (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
exports.ParagraphElement = ParagraphElement;
